export default function Logo({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" data-testid="logo-mark">
      <rect width="48" height="48" rx="14" fill="#18382B" />
      <path
        d="M14 36V20l10-6v22"
        fill="none"
        stroke="#F7F5F0"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 36V24l10-5v17"
        fill="none"
        stroke="#F7F5F0"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M30 12c3.2.4 5.2 2.4 5.6 5.6-3.2-.4-5.2-2.4-5.6-5.6z" fill="#7FC8A9" />
    </svg>
  );
}
